import React from 'react';
import { Select, Input, AutoComplete, Button, Form, Icon, Tooltip, Avatar, message, Popconfirm, Popover } from 'antd';
import SERVER_URL from '../Global';
import { Row, Col } from 'reactstrap';
import HandleHr from '../Wizard/HandleHr';
import EditHr from './EditHr';

const { Option } = Select;

message.config({
    top: 100,
    duration: 2,
    maxCount: 1
});

class EditRole extends React.Component {
    constructor(props) {
        super(props);

        let collabName = ''
        let isHr = true
        let roleId = this.props.roleId
        let hrs = []
        let newHrId = 0
        let hrOrderList = []
        let hrCreated = true
        let roleName = null
        let mandatoryCollab = false
        let collabId = ''

        this.props.data.brHrRoleOfficies.map((br, i) => {            
            if (br.workingFor != null) {
                if (br.workingFor.officeId == this.props.data.officeId) {
                    br.workingFor.office = this.props.data
                }
            }

            if (br.roleId == roleId && br.hrId != null) {
                hrs.push(br)
                hrOrderList.push({ id: newHrId, order: newHrId + 1 })
                newHrId++
                hrCreated = true
            } else if (br.roleId == roleId && br.brHrRoleOfficeContacts.length > 0) {
                hrs.push(br)
                hrOrderList.push({ id: newHrId, order: newHrId + 1 })
                newHrId++
                hrCreated = true
            } else if (br.roleId == roleId && br.workingFor != null) {
                if (br.workingFor.office.addresses.length > 0 && br.showAddressWorkingFor && br.workingFor != null) {
                    if (br.workingFor.office.addresses[0].officeId == br.workingFor.officeId)
                        hrs.push(br)
                    hrOrderList.push({ id: newHrId, order: newHrId + 1 })
                    newHrId++
                    hrCreated = true
                }
            }

            if (br.roleId == roleId && br.role.name !== '') {
                roleName = br.role.name
                if (br.workingFor != null) {
                    isHr = false
                    collabName = br.workingFor.office.company.name
                    mandatoryCollab = true
                    collabId = br.workingForHROId
                }
            }
        })


        this.state = {
            hrOrderList: hrOrderList,
            hrs: hrs,
            user: this.props.user,
            officeId: this.props.office,
            loading: true,
            hrCreated: hrCreated,
            hroidCreated: false,
            roleCreated: true,
            roleDeleted: false,
            properties: this.props.properties,
            companies: [],
            contactsHr: ['0'],
            contactHrId: 0,
            hrName: '',
            hrSurname: '',
            roleName: roleName,
            hrId: '',
            hroId: this.props.data.hroId,
            hrContactText: '',
            roleId: this.props.roleId,
            isHr: isHr,
            companyId: '',
            newHr: [],
            newHrId: newHrId,
            collabId: collabId,
            basicHroid: '',
            roleUpdated: true,
            sortRole: 10,
            mandatoryRole: true,
            editHr: this.props.data,
            collabName: collabName,
            display: "flex",
            hrHasToBeShown: true,
            deletedHr: 0,
            roleUpdatedOrder: true,
            mandatoryCollab: mandatoryCollab,
            noDetailsHrCounter: 0,
        };

        this.handleProp = this.handleProp.bind(this);
        this.handleRole = this.handleRole.bind(this);
        this.hrOrCompany = this.hrOrCompany.bind(this);
        this.searchCompany = this.searchCompany.bind(this);
        this.handleCollab = this.handleCollab.bind(this);
        this.addHr = this.addHr.bind(this);
        this.handleSurnameChange = this.handleSurnameChange.bind(this);
        this.saveRole = this.saveRole.bind(this);
        this.sortRole = this.sortRole.bind(this);
        this.deleteRole = this.deleteRole.bind(this);
        this.sendDataRoleSaved = this.sendDataRoleSaved.bind(this);
        this.sendCounterToHandleOffice = this.sendCounterToHandleOffice.bind(this);
        this.sendDataToHandleOffice = this.sendDataToHandleOffice.bind(this);

        if (this.state.properties.length < 1) {
            //proprietà
            fetch(
                `${SERVER_URL + 'api/translation/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "typeTip": "Property",
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 40,
                        "pageSizeOptions": null,
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ properties: res.data }, this.setState({ propLoad: false }));
                })
        }
    }

    componentDidUpdate(propsPrecedenti) {
        // Utilizzo tipico (non dimenticarti di comparare le props):
        if (this.props.roleUpdatedOrder !== propsPrecedenti.roleUpdatedOrder) {
            this.setState({ roleUpdatedOrder: this.props.roleUpdatedOrder });
        }
    }

    handleRole(event) {
        this.setState({ roleName: event.target.value, mandatoryRole: true, roleUpdated: false, });
        if (event.target.value.length === 0) {
            this.setState({ mandatoryRole: false, roleName: null })
        }
    }

    sortRole(value) {
        this.setState({ sortRole: value });
    }

    handleProp(value) {
        this.setState({ propId: value });
    }

    addContactHr() {
        var id = this.state.contactHrId;

        const $ = window.$;
        $("#contactHr" + id).addClass("disabled");

        this.setState({ contactHrId: this.state.contactHrId + 1 })
        this.state.contactsHr.push(`${id + 1}`)
    }

    saveRole(e) {
        e.preventDefault();

        if (this.state.roleCreated === false && this.state.isHr === true && this.state.mandatoryRole && this.state.roleName !== '') {
            fetch(
                `${SERVER_URL + "api/role"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.roleName,
                        "Status": this.props.status,
                        "Sort": this.props.order
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ roleCreated: true, roleId: res.data, roleUpdated: true, roleDeleted: false, roleUpdated: true });
                    this.sendDataRoleSaved();
                })
        }
        if (this.state.roleCreated === false && this.state.isHr === true && !this.state.mandatoryRole) {
            //stai creando un hr senza aver creato un ruolo
        }
        if (this.state.roleCreated === false && this.state.isHr === false && this.state.collabId !== '' && this.state.roleName !== '') {
            fetch(
                `${SERVER_URL + "api/role"}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.roleName,
                        "Status": this.props.status,
                        "Sort": this.props.order
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ roleId: res.data });

                    fetch(
                        `${SERVER_URL + "api/brHrRoleOffice"}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${this.state.user}`
                            },
                            body: JSON.stringify({
                                "officeId": this.state.officeId,
                                "roleId": this.state.roleId,
                                "WorkingForHROId": this.state.collabId,
                                "Status": this.props.status
                            })
                        }
                    ).then(response => response.json())
                        .then(res => {
                            this.setState({ roleCreated: true, basicHroid: res.data, roleDeleted: false, roleUpdated: true });
                            this.sendDataRoleSaved();
                        })
                })
        }
        if (this.state.roleCreated === true && this.state.roleName !== '') {
            fetch(
                `${SERVER_URL + "api/role"}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.state.user}`
                    },
                    body: JSON.stringify({
                        'name': this.state.roleName,
                        'roleid': `${this.state.roleId}`,
                        "Status": this.props.status,
                        "Sort": this.props.order
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    this.setState({ loading: false, roleUpdated: true });
                })
            this.sendDataRoleSaved();

        }
        if (this.state.handleCollab === '' && this.state.isHr === true) {
            //stai creando una collab senza aver selezionato una collab
        }
    }


    componentDidUpdate(prevProps) {
        // Typical usage (don't forget to compare props):
        if (this.props.order !== prevProps.order && this.state.roleCreated) {
            this.newOrder(this.props.order);
        }
    }

    newOrder(order) {
        fetch(
            `${SERVER_URL + "api/role"}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.state.user}`
                },
                body: JSON.stringify({
                    'name': this.state.roleName,
                    'roleid': `${this.state.roleId}`,
                    "Status": this.props.status,
                    "Sort": order
                })
            }
        ).then(response => response.json())
            .then(res => {
            })
    }

    deleteRole() {
        if (this.state.roleCreated) {
            fetch(
                `${SERVER_URL + 'api/role/hard/' + this.state.roleId}`, {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    }
                }
            )

            this.setState({ roleCreated: false, roleDeleted: true, roleName: '', roleCreated: false, isHr: true });
            this.sendCounterToHandleOffice();
            this.sendDataToHandleOffice(this.props.i)
        }
    }

    hrOrCompany(event) {
        this.setState({ isHr: event });
    }

    addHr() {
        if (this.state.mandatoryRole) {
            var newId = this.state.newHrId
            this.setState({ newHrId: this.state.newHrId + 1, hrCreated: false });
            this.state.hrOrderList.push({ id: newId, order: newId + 1 })
            this.state.newHr.push(`${newId}`)
        }
    }

    handleSurnameChange(event) {
        this.setState({ hrSurname: event.target.value });
    }

    searchCompany(value) {
        if (value.length >= 3 || value.length === 0) {
            //companies
            fetch(
                `${SERVER_URL + 'api/company/list'}`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${this.state.user}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        "CompanyName": `${value}`,
                        "page": 1,
                        "totalPages": 0,
                        "totalItems": 0,
                        "pageSize": 15,
                        "pageSizeOptions": null,
                        "TypologyName": "Company",
                        "ordering": {
                            "orderPropertyName": 'name',
                            "order": 1
                        },
                        "firstItemNumber": 0,
                        "lastItemNumber": 0,
                        "entityId": 0
                    })
                }
            ).then(response => response.json())
                .then(res => {
                    if (res.data != null) {
                        this.setState({ companies: res.data });
                    } else {
                        this.setState({ loading: false });
                        //non trova la comp
                    }
                })
        }
    }

    sendCounterToHandleOffice = () => {
        this.props.parentCounterDeletedRole(1);
    }

    sendDataToHandleOffice = () => {
        this.props.showOrderButtons(false, this.props.i);
    }

    orderDown(index) {

        if (this.state.hrOrderList[index].order !== 1) {
            let newOrderList = this.state.hrOrderList;
            var indexOrder = newOrderList.findIndex(obj => obj.order == this.state.hrOrderList[index].order - 1);
            newOrderList[index].order = this.state.hrOrderList[index].order - 1;
            newOrderList[indexOrder].order = this.state.hrOrderList[indexOrder].order + 1;
            this.setState({ hrOrderList: newOrderList })
        }
    }

    orderUp(index) {

        if (this.state.hrOrderList.length > this.state.hrOrderList[index].order) {
            let newOrderList = this.state.hrOrderList;
            var indexOrder = newOrderList.findIndex(obj => obj.order == this.state.hrOrderList[index].order + 1);
            newOrderList[index].order = this.state.hrOrderList[index].order + 1;
            newOrderList[indexOrder].order = this.state.hrOrderList[indexOrder].order - 1;
            this.setState({ hrOrderList: newOrderList })
        }
    }

    handleCollab(value) {
        fetch(
            `${SERVER_URL + 'api/company/home'}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.state.user}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    "companyId": value,
                    "page": 1,
                    "totalPages": 0,
                    "totalItems": 0,
                    "pageSize": 1,
                    "pageSizeOptions": null,
                    "ordering": {
                        "orderPropertyName": 'name',
                        "order": 1
                    },
                    "firstItemNumber": 0,
                    "lastItemNumber": 0,
                    "entityId": 0
                })
            }
        ).then(response => response.json())
            .then(res => {
                fetch(
                    `${SERVER_URL + 'api/brHrRoleOffice/list'}`, {
                        method: 'POST',
                        headers: {
                            'Authorization': `Bearer ${this.state.user}`,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            "officeId": res.data[0].offices[0].officeId,
                            "hrId": null,
                            "page": 1,
                            "totalPages": 0,
                            "totalItems": 0,
                            "pageSize": 999,
                            "pageSizeOptions": null,
                            "firstItemNumber": 0,
                            "lastItemNumber": 0,
                            "entityId": 0
                        })
                    }
                ).then(response => response.json())
                    .then(newres => {
                        newres.data.map(n => {
                            if (n.hrId == null && n.roleId == null && n.WorkingForHROId == null) {
                                this.setState({ collabId: n.hroId })
                            }
                        })
                    })
            }
            )
    }

    showOrderButtons = (hrData, id) => {
        this.state.hrOrderList[id].deleted = true;
        this.setState({ hrHasToBeShown: hrData })
    }

    counterDeletedHr = (childData) => {
        let hrdeleted = parseInt(this.state.deletedHr)
        let counter = hrdeleted + childData;
        this.setState({ deletedHr: counter })

    }

    callbackHrCreatedFunction = (childData) => {
        this.setState({ hrCreated: childData })
    }

    sendDataRoleSaved = () => {
        this.props.parentCallbackRoleSaved(true);
    }

    callbacknoDetailsHrCounter = (childData) => {
        this.setState({ noDetailsHrCounter: childData })
    }

    callbackOrder = (childData) => {
        var i;
        for (i = 0; i < childData; i++) {
            this.orderDown(childData)
        }

    }

    render() {

        let mandatoryCollab = this.state.isHr ? "" : !this.state.mandatoryCollab ? <Tooltip title="This field is mandatory"><Icon style={{ marginTop: '36px' }} type="exclamation-circle" /></Tooltip> : <Icon style={{ marginTop: '36px' }} type="check-circle" />

        let mandatory1 = !this.state.mandatoryRole ? <Tooltip title="This field is mandatory"><Icon type="exclamation-circle" /></Tooltip> : <Icon type="check-circle" />

        let hrOrCompany = this.state.isHr ? <Avatar shape="square" size={70} icon="user" /> : <Avatar shape="square" size={70} icon="solution" />

        let mandatoryAreNotMet = <p>One or more mandatory fields are empty</p>

        let allSaved = <p>Everything is already Saved</p>

        let isRoleSavable = !this.state.isHr ? this.state.mandatoryCollab && this.state.mandatoryRole ? this.state.roleUpdated ? <Popover content={allSaved}> <Button disabled className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button></Popover> : <Button onClick={this.saveRole} className="saveButtonHrWizard saveRole"><Icon type="save" /> Save Role</Button> : <Popover content={mandatoryAreNotMet}> <Button disabled className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button></Popover> : this.state.mandatoryRole ? this.state.roleUpdated ? <Popover content={allSaved}> <Button disabled className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button></Popover> : <Button onClick={this.saveRole} className="saveButtonHrWizard saveRole"><Icon type="save" /> Save Role</Button> : <Popover content={mandatoryAreNotMet}> <Button disabled className="saveButtonHrWizard saveRole"><Icon type="save" />Save Role</Button></Popover>

        let listacompany = this.state.companies.map(comp =>
            <Option key={comp.companyId}>{comp.name}</Option>
        )

        let roleDelete = this.state.roleCreated ? <Popconfirm placement="top" title="Are you sure you want to delete this Role, given that the HR will not be deleted?" onConfirm={this.deleteRole} okText="Yes" cancelText="No"> <Button className="deleteButtonHrWizard deleteRole"><Icon type="close" />Delete Role</Button></Popconfirm> : <Button disabled className="deleteButtonHrWizard deleteRole"><Icon type="close" />Delete Role</Button>

        let compOrHr = this.state.isHr ? '' :
            <div style={{ width: '100%', display: 'inline-flex' }}>
                <AutoComplete
                    dataSource={listacompany}
                    style={{ width: 'calc(100% - 32px)', marginTop: '20px', marginRight: '14px' }}
                    onSelect={this.handleCollab}
                    onChange={this.searchCompany}
                    placeholder="Collaboration"
                    defaultValue={this.state.collabName}
                    disabled
                />
                {mandatoryCollab}
            </div>

        let ifRoleOk = this.state.roleCreated ?
            this.state.newHr.map(i => {
                var num = parseInt(i, 10);
                let x = parseInt(i) + 1;
                var index = this.state.hrOrderList.findIndex(obj => obj.id == i);

                let hrNotDeleted = !this.state.hrOrderList[num].deleted ?
                    <div>
                        <div className="orderArrowsHr">
                            {<Button className="hrOrderButton" type="primary" icon="caret-up" onClick={() => this.orderDown(index)} />}
                            <br />
                            <div className="hrOrderNumber">{this.state.hrOrderList[index].order}</div>
                            <br />
                            {<Button className="hrOrderButton" type="primary" icon="caret-down" onClick={() => this.orderUp(index)} />}
                        </div>
                        <HandleHr parentCallbackOrder={this.callbackOrder} noDetailsHrCounter={this.state.noDetailsHrCounter} parentnoDetailsCounter={this.state.noDetailsHrCounter} parentnoDetailsCounter={this.callbacknoDetailsHrCounter} callbackHrIsCreated={this.callbackHrCreatedFunction} parentCounterDeletedHr={this.counterDeletedHr} showOrderButtons={this.showOrderButtons} handleId={this.state.hrOrderList[index].id} order={this.state.hrOrderList[index].order} status={this.props.status} collabContacts={null} collabHrs={null} collab={null} roleId={this.state.roleId} collabId={this.state.collabId} basicHroid={this.state.basicHroid} i={num} isHr={this.state.isHr} properties={this.state.properties} officeId={this.state.officeId} roleStatus={this.state.roleCreated} user={this.state.user} />
                    </div> : ""

                return (
                    <li key={x} style={{ order: this.state.hrOrderList[index].order, listStyle: 'none' }}>
                        {hrNotDeleted}
                    </li>
                )
            }) : ""

        let addNewHr = !this.state.roleCreated ? "" : this.state.hrCreated ? <Button onClick={this.addHr} className="createHrButton" icon="plus">Hr</Button> : <Button disabled onClick={this.addHr} className="createHrButton" icon="plus">Hr</Button>

        let showRole = this.state.roleDeleted ? "" :
            <Row className={"wizardHrCreation " + this.state.roleCreated + "classRoleSaved" + this.state.roleUpdated + " marginFF"} id={this.state.officeId + "roleBox" + this.props.order} name={this.state.officeId + "roleBox" + this.props.order} style={{ marginTop: '-120px' }}>
                <Col xl="12" className="handleRoleBox">
                    <div style={{ width: '100%', height: 'auto' }} className="wizardSelect">
                        {hrOrCompany}
                        {compOrHr}
                        <Form>

                            <Tooltip placement="topLeft" title="Insert here the role name for one or more HRs">
                                <h4><Icon type="info-circle" /> Role name:</h4>
                            </Tooltip>

                            <Input autoComplete="new-password" value={this.state.roleName} className="contactText" className={this.state.roleCreated + "classRoleSaved" + this.state.roleUpdated} style={{ width: 'calc(100% - 32px)', marginRight: '14px', height: '100%' }} allowClear={true} placeholder="Role" onChange={this.handleRole} />
                            {mandatory1}
                        </Form>

                        <ul style={{ padding: '0', display: 'flex', flexDirection: 'column' }}>
                            {this.state.hrs.map((hr, i) => {
                                var num = parseInt(i, 10);
                                let x = parseInt(i) + 1;
                                var index = this.state.hrOrderList.findIndex(obj => obj.id == i);

                                let hrNotDeleted = !this.state.hrOrderList[num].deleted ?
                                    <div>
                                        <div className="orderArrowsHr">
                                            {<Button className="hrOrderButton" type="primary" icon="caret-up" onClick={() => this.orderDown(index)} />}
                                            <br />
                                            <div className="hrOrderNumber">{this.state.hrOrderList[index].order}</div>
                                            <br />
                                            {<Button className="hrOrderButton" type="primary" icon="caret-down" onClick={() => this.orderUp(index)} />}
                                        </div>
                                        <EditHr parentCallbackOrder={this.callbackOrder} noDetailsHrCounter={this.state.noDetailsHrCounter} parentnoDetailsCounter={this.callbacknoDetailsHrCounter} callbackHrIsCreated={this.callbackHrCreatedFunction} parentCounterDeletedHr={this.counterDeletedHr} showOrderButtons={this.showOrderButtons} handleId={this.state.hrOrderList[index].id} order={this.state.hrOrderList[index].order} data={hr} key={hr.hroId} status={this.props.status} collabId={this.state.collabId} basicHroid={this.state.basicHroid} i={0} isHr={this.state.isHr} properties={this.state.properties} roleId={this.state.roleId} officeId={this.state.officeId} roleStatus={this.state.roleCreated} user={this.state.user} />
                                    </div> : ""
                                return (
                                    <li key={x} style={{ order: this.state.hrOrderList[index].order, listStyle: 'none' }}>
                                        {hrNotDeleted}
                                    </li>
                                )
                            })
                            }
                            {ifRoleOk}
                        </ul>
                        {addNewHr}
                    </div>
                    <div style={{ display: 'inline-flex', width: '100%' }}>
                        <div className="pulsantiRole" style={{ display: 'inline-flex' }}>
                            {isRoleSavable}
                            {roleDelete}
                        </div>
                    </div>
                </Col>
            </Row>

        return (
            <div>
                {showRole}
            </div>
        );
    }
}

export default EditRole;


// WEBPACK FOOTER //
// ./src/EditWizard/EditRole.js